import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import logo from "../assets/new-fire-score-logo.png";
import { useLanguage } from "../context/LanguageContext";

const LoginPage: React.FC<{ onLogin: (isAuthenticated: boolean) => void }> = ({ onLogin }) => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const { t } = useLanguage();

    const handleLogin = (e: React.FormEvent) => {
        e.preventDefault();
        if (username === "admin" && password === "password123") {
            setError("");
            onLogin(true); // Trigger login in App.tsx
            navigate("/");
        } else {
            setError(t("invalid_credentials"));
        }
    };

    return (
        <div className="min-h-screen bg-gray-100 flex items-center justify-center">
            <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
                className="bg-white p-8 rounded-xl shadow-lg w-full max-w-md"
            >
                
                <h2 className="text-2xl font-bold text-gray-800 text-center mb-6">{t("login")}</h2>
                <form onSubmit={handleLogin} className="space-y-6">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">{t("username")}</label>
                        <input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            className="w-full mt-1 p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            placeholder={t("enter_username")}
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">{t("password")}</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full mt-1 p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            placeholder={t("enter_password")}
                        />
                    </div>
                    {error && <p className="text-red-500 text-sm text-center">{error}</p>}
                    <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        type="submit"
                        className="w-full bg-gradient-to-r from-blue-500 to-indigo-500 text-white py-2 rounded-lg font-medium hover:from-blue-600 hover:to-indigo-600 transition-all duration-200"
                    >
                        {t("login")}
                    </motion.button>
                </form>
            </motion.div>
        </div>
    );
};

export default LoginPage;